export enum CplItemSubType {
    NONE = 0,
    FLEX = 1,
    CLEARANCE = 2
}